module.exports = __webpack_public_path__ + "img/001.fd44ec11.png";